import { createSelector } from 'reselect';

import { Label } from '@r1-frontend/ui-react/components/label';
import { Flash } from '@r1-frontend/ui-react/components/svg/main';
import { truncate } from '@r1-frontend/shared/helpers/truncate';

import { IPreparedRouter } from '~/src/entities/speed-bonus/context/actions/setRouters';
import { getLimits } from '~/src/entities/speed-bonus/context/helpers';
import { TInitialState } from '~/src/entities/speed-bonus/context/reducer';

const prepareCharacteristic = (elem: { title: string, value: string }) => {
    const maxTitle = 20;
    const maxValue = 12;

    return {
        ...elem,
        title: truncate(elem.title, maxTitle),
        value: truncate(elem.value, maxValue),
        Icon: Flash,
    };
};

type TCharacteristic = ReturnType<typeof prepareCharacteristic>;

export type TRouter = IPreparedRouter & {
    characteristics: TCharacteristic[],
    labelElements: JSX.Element[],
    disabled: boolean,
    isInstalmentLimit: boolean,
}

export const selectRouters = createSelector(
    [
        (state: TInitialState) => state.routers,
    ],
    (routers): TRouter[] => {
        const limits = getLimits(routers);

        return routers.reduce<TRouter[]>((acc, router) => {
            const isInstallmentLimit = !!(router.selectedPrice.duration && limits.installment && router.quantity);
            const characteristics = router.props.slice(0, 3).map(prepareCharacteristic);
            const labelElements = router.labels.map(label => (
                <Label key={label.id} bgColor={label.color} textColor={label.color_text}>{label.title}</Label>
            ));

            acc.push({
                ...router,
                images: [router.image, ...router.images],
                characteristics,
                labelElements,
                disabled: limits.total || isInstallmentLimit,
                isInstalmentLimit: limits.installment,
            });

            return acc;
        }, []);
    },
);
